import React from 'react';
import Overview from '../Account/Pages/Overview';
import { StandaloneSendsAdminUsersRoutes, StandaloneSendsUsersRoutes } from '../SendsProfiles/StandaloneSendsRoutes';
import { SettingsRoutes } from '../Settings/SettingsRoutes';
import { SuggestibleRouteInterface } from './Types/RouteTypes';

const TopRoutes: Array<SuggestibleRouteInterface> = [
	{
		title: 'Overview',
		path: '/',
		element: <Overview />,
	},
	...StandaloneSendsUsersRoutes,
	...StandaloneSendsAdminUsersRoutes,
	...SettingsRoutes,
];

export default TopRoutes;
